import useRollupKeyFields from './useRollupKeyFields'

type UseLineItemRollupAvailableOptions = {
  enabled?: boolean
}

/**
 * Line item rollup only applies when the project actually has something to
 * roll up by — the same eligible key fields the Configs tab uses to build a
 * grouping key. Available === that list is non-empty, kept in lockstep via
 * useRollupKeyFields so the two can't drift. Gates both the settings nav item
 * and the page itself.
 */
export default function useLineItemRollupAvailable({
  enabled = true,
}: UseLineItemRollupAvailableOptions = {}) {
  const { keyFields, isPending } = useRollupKeyFields({ enabled })

  return { isAvailable: keyFields.length > 0, isPending }
}
